import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeletePledgeShopCharityMutation = createMutationHook(
  CreatorIntegrationsApiClient.deletePledgeShopCharity,
  {
    mutationKey: ['deletePledgeShopCharity'],
  },
)
